<div class="search" style="justify-content: space-between;">
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Subscribers..."' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
    <div style="display: flex; align-items: center; margin-right: 10px;">
        <label id="event" style="padding: 0 15px 0 0; text-align: center;">Filter by Campaign</label>
        <select
            style="width: 200px; color: black; height: 37px; margin-left: 5px; display: inline;"
            id="campaign"
            class="form-control m-input"
            [(ngModel)]="selectedCampaign"
            (change)="filterByCampaign()"
            name="campaign">
        <option
            [ngValue]="0">
            -- Reset Selection --
        </option>
        <option
            [ngValue]="-1">
            -- No Active Subscriptions --
        </option>
        <option *ngFor="let ppw of ppws"
            [ngValue]="ppw.pledgePerWinId">
            {{ppw.event.name}}
        </option>

        </select>
    </div>
    <div>
        <button
            [disabled]="items?.length < 1"
            style="box-shadow: 0 3px 15px 6px rgba(120, 99, 225, 0.22);"
            class="btn btn-success"
            (click)="generateSubscriberReport()">
            Generate Subscriber Report
        </button>
    </div>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable
    #packageTable
    class='material striped datatable'
    [rows]='display'
    [columnMode]='"force"'
    [headerHeight]='40'
    [sorts]="[{prop: 'operatorId', dir: 'desc'}]"
    [footerHeight]='20'
    [scrollbarH]="true"
    [scrollbarV]="true"
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="name" [sortable]="true" width="200">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Subscriber Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.firstName}} {{row.lastName}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="email" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Email
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.email}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="phone" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Phone
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.phone}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [sortable]="true" width="200">
      <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
              <span (click)="sort()">
                  Status
              </span>
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        {{isActive(row.subscriptions) ? 'Active' : 'No active subscriptions'}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="200" [maxWidth]="200">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button style="float: right;" class="btn btn-danger btn-icon" (click)="cancelOrReverse(row.pledgePerWinSubscriberId)" tooltip="Cancel/Reverse"><i class="flaticon-cancel"></i></button>
            <button style="float: right;" class="btn btn-success btn-icon" (click)="openDetailsModal(row.pledgePerWinSubscriberId)" tooltip="Details"><i class="flaticon-clipboard"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>
